import React from 'react';
import PropTypes from 'prop-types';
//import moment from 'moment';

export default class DriverBadge extends React.PureComponent {

    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div className="driver-badge">
                {this.props.driverName}
            </div>
        )
    }
}

DriverBadge.propTypes = {
    driverName: PropTypes.string.isRequired
    //startDate: PropTypes.instanceOf(Date).isRequired
};
